import { appConfig } from 'config/appConfig';

export const generateRandomPw = () => {
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const specials = '!@#$%^&*()_+~`|}{[]:;?><,./-=';
  const allChars = lowercase + uppercase + numbers + specials;

  let pw = '';
  Array.from({ length: 4 }).forEach(() => {
    const crypto = window.crypto || window.Crypto;
    const array = new Uint32Array(1);
    const randomChar =
      allChars[Math.floor(Number('0.' + crypto.getRandomValues(array)) * allChars.length)];
    pw += randomChar;
  });

  return `${pw}JLL${new Date().getFullYear()}`;
};

export const getHmacForField = async (field) => {
  const crypto = window.crypto.subtle || window.Crypto.subtle;

  const seed = appConfig.TRACKING_SERVICES_KEY;
  const enc = new TextEncoder();
  const algorithm = { name: 'HMAC', hash: 'SHA-256' };

  const key = await crypto.importKey('raw', enc.encode(seed), algorithm, false, ['sign', 'verify']);
  const signature = await crypto.sign(algorithm.name, key, enc.encode(field));
  const hashArray = Array.from(new Uint8Array(signature));
  const digest = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

  return digest;
};
